module.exports = __webpack_public_path__ + "files/84dab8682754439b6c15ca99d00b9ca4.png";